"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("UserSelectModal", _vm._b({
    attrs: {
      "default-selected-user-ids": _vm.selectedUserIds,
      "default-selected-users": _vm.selectedUsers
    },
    on: {
      ok: _vm.handleOk
    }
  }, "UserSelectModal", _vm.$props, false)), _vm.showCount ? _c("div", {
    staticClass: "m-flex m-m-t-4",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_c("a-button", {
    staticClass: "m-m-r-8",
    attrs: {
      disabled: _vm.batchDelUserIds.length === 0,
      type: "danger"
    },
    on: {
      click: _vm.handleBatchDel
    }
  }, [_vm._v("批量删除")]), _vm._v(" 已选择 "), _c("span", {
    staticClass: "m-type-primary m-m-h-4"
  }, [_vm._v(_vm._s(_vm.selectedUsers.length))]), _vm._v(" 人 ")], 1) : _vm._e(), _c("BasisTable", {
    staticClass: "m-m-t-4",
    attrs: {
      selectable: true,
      pagination: _vm.pagination,
      bordered: true,
      scroll: _vm.scroll,
      "empty-desc": "暂无数据，请先选择人员",
      "row-key": "userId",
      columns: _vm.columns,
      "data-source": _vm.selectedUsers
    },
    scopedSlots: _vm._u([{
      key: "operation",
      fn: function ({
        record
      }) {
        return [!record.disabled ? _c("a", {
          on: {
            click: function ($event) {
              return _vm.handleDel(record.userId);
            }
          }
        }, [_vm._v("删除")]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.batchDelUserIds,
      callback: function ($$v) {
        _vm.batchDelUserIds = $$v;
      },
      expression: "batchDelUserIds"
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;